import moment from 'moment'

import actionDeadlineFilter from 'app/filters/actionDeadline'

export default function(deadline, issueDate){

    deadline = actionDeadlineFilter(deadline);

    const date = moment(issueDate);
    date.add(deadline, 'days');

    return date.format("YYYY-MM-DD");
}